import { createSelector } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "shared/constants";
import { buildSingleItem } from "shared/utils";

import { IDataKeys, IPaginationItem } from "shared/types";
import { IEquipment } from "Venues/types";
import { dataSelector } from "./helpers";

export const equipmentSelector = ({
  paths,
  itemIds,
}: {
  paths?: string[];
  itemIds?: string[];
}) =>
  createSelector(dataSelector, (data) => {
    let pathsFromIds = paths || [];

    if (!pathsFromIds.length && itemIds) {
      pathsFromIds = itemIds.map((id) => API_ENDPOINTS.EQUIPMENT(id));
    }

    return pathsFromIds
      .map((path) => {
        const item = data[IDataKeys.equipment]?.[path];

        return item
          ? (buildSingleItem(item) as IEquipment)
          : ({} as IEquipment);
      })
      .filter((item) => Object.keys(item).length);
  });

export const paginatedEquipmentSelector = (pagination: IPaginationItem) => {
  const paths = pagination.pages?.[pagination.currentPage] || [];

  return equipmentSelector({ paths });
};
